import App from './App.svelte';
import * as Sentry from "@sentry/browser";

Sentry.init({
    dsn: process.env.APP_SENTRY_DSN,
    //integrations: [new BrowserTracing()],
    environment: process.env.APP_ENV
});

/*let app;
(async function start() {
    try {
        await initYears();
    } catch (err) {
        console.error('Échec de chargement de years.json', err);
    }

    app = new App({
        target: document.body,
        props: {
            API_URL: process.env.APP_API_URL,
            API_URL_PUBLIC: process.env.APP_API_URL_PUBLIC,
            privateVersion: process.env.APP_privateVersion === "true"
        }
    });
})();*/

const app = new App({
    target: document.body,
    props: {
        API_URL: process.env.APP_API_URL,
        API_URL_PUBLIC: process.env.APP_API_URL_PUBLIC,
        privateVersion: process.env.APP_privateVersion === "true"
    }
});

export default app;
